export { default } from './PlayerMinutaminutAudio';
